export const CT_PERSONALIZATION_TYPES = {
  MLP: 'mlp',
  NEW_BUILD: 'new-build',
  RESUME_BUILD: 'resume-build',
};

export const CT_PERSONALIZATION_CTA_TEXT = {
  mlp: 'Explore',
  new_build: 'Build',
  resume_build: 'Build',
};
